import { lazy, Suspense, useEffect } from "react";
import { createFileRoute } from "@tanstack/react-router";

// Lazy load the actual component
const LoginComponent = lazy(() => import("../../../components/auth-layout/auth/LoginComponent"));

export const Route = createFileRoute("/_public/_layout/login")({
  component: RouteComponent,
  loader: async () => {
    await import("../../../components/auth-layout/auth/LoginComponent");
    return null;
  },
});

function RouteComponent() {
  // useNavigate returns the navigate function directly
  const navigate = useNavigate();
  const privyToken = localStorage.getItem("privyToken");

  useEffect(() => {
    if (privyToken) {
      navigate({ to: "/" });
    }
  }, [privyToken, navigate]);
  
  return (
    <Suspense fallback={<div>Loading login page...</div>}>
      <LoginComponent navigate={navigate} />
    </Suspense>
  );
}

// Import at the end to avoid circular dependency issues
import { useNavigate } from "@tanstack/react-router";
